<template>
  <div class="animated fadeIn companies--companies-list d-flex flex-column">
    <fixed-header :title="'Contacts List'" :records="pageInfo.totalItems" hideNewOfferBtn hideBackBtn>
      <div class="buttons-panel m-0">
        <b-button size="sm" variant="primary" class="btn btn-primary mr-2" @click="openTodoModal" :disabled="selectedRowItemId == 0">
          <i class="fa fa-plus" aria-hidden="true"></i> Add Task
        </b-button>
        <b-button variant="primary" class="mr-2" size="sm" @click="onSendEmail" :disabled="checkedContacts.length == 0">
          Send Email
        </b-button>
        <b-button v-if="checkClaim(CAN_ADD_REQUIREMENTS)" @click="redirectToAddRequirement" class="mr-2" size="sm" variant="primary">
          <i class="fa fa-plus" aria-hidden="true"></i>
          Add requirement
        </b-button>
        <b-button variant="danger" @click="onMultiDeleteContacts" class="mr-2" size="sm" :disabled="!checkedContacts.length || onMultiDeleting"> 
          <i class="fa fa-trash"></i>
          Delete
        </b-button>
      </div>
    </fixed-header>
    <b-card>
      <div>
        <div class="d-flex justify-content-start align-items-end mb-2">
          <b-form-group label="Name" class="mr-2">
            <b-form-input size="sm" v-model="filterObj.fullName" @input="onSearch"/>
          </b-form-group>
          <b-form-group label="Email" class="mr-2">
            <b-form-input size="sm" v-model="filterObj.email1" @input="onSearch"/>
          </b-form-group>
          <b-form-group label="Phone" class="mr-2">
            <b-form-input size="sm" v-model="filterObj.main" @input="onSearch"/>
          </b-form-group>
          <b-form-group label="Company" class="mr-2">
            <b-form-input size="sm" v-model="filterObj.companyName" @input="onSearch"/>
          </b-form-group>
          <b-form-group label="Type" class="mr-2">
            <b-form-select v-model="filterObj.accountTypeId" @change="onSearch">
              <option :value="null">All</option>
              <option
                v-for="(type) in sortSelect(sortedAccountTypes)"
                :key="type.id"
                :value="type.id"
              >{{type.name}}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Company Attribute" class="mr-2">
            <b-form-select v-model="filterObj.attributeId" @change="onSearch">
              <option :value="null">All</option>
              <option
                v-for="(type) in sortSelect(filteredAttributes,'attributeName')"
                :key="type.id"
                :value="type.id"
              >{{type.attributeName}}</option>
            </b-form-select>
          </b-form-group>
          
          <b-form-group label="Company Class" class="mr-2">
            <b-form-select v-model="filterObj.accountClassId" @change="onSearch">
              <option :value="null">All</option>
              <option
                v-for="(type) in sortSelect(accountClasses)"
                :key="type.id"
                :value="type.id"
              >{{type.name}}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Country" class="mr-2" style="width: 150px !important;">
            <b-form-select v-model="filterObj.country" @change="onSearch">
              <option :value="null">All</option>
              <option v-for="(countryCode) in sortSelect(countryCodes,'country')" v-bind:key="countryCode.code2"
                      v-bind:value="countryCode.country">{{countryCode.country}}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="State" class="mr-2">
            <b-form-input size="sm" v-model="filterObj.state" @input="onSearch" />
          </b-form-group>
          <b-form-group label="Salesperson" class="mr-2" v-if="checkClaim(CAN_VIEW_ALL_COMPANIES)">
            <b-form-select v-model="filterObj.salesPersonUserId" @change="onSearch">
              <option :value="null">All</option>
              <option :value="'unassigned'">Unassigned</option>
              <option
                v-for="(selectRep, indexRep) in sortSelect(salesReps)"
                :key="indexRep"
                :value="selectRep.id"
              >{{ selectRep.name }}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Alt Salesperson" class="mr-2">
            <b-form-select v-model="filterObj.salesPerson2UserId" @change="onSearch">
              <option :value="null">All</option>
              <option :value="'unassigned'">Unassigned</option>
              <option
                v-for="(selectRep, indexRep) in sortSelect(salesReps)"
                :key="indexRep"
                :value="selectRep.id"
              >{{ selectRep.name }}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Buyer" class="mr-2">
            <b-form-select v-model="filterObj.buyerPersonUserId" @input="onSearch" >
              <option :value="null">All</option>
              <option :value="'unassigned'">Unassigned</option>
              <option v-for="(selectRep, indexRep) in sortSelect(buyerReps)" :key="indexRep" :value="selectRep.id">
                {{ selectRep.name }}</option>
            </b-form-select>
          </b-form-group>
          <div class="clear-filter-button-container">
            <b-button size="sm" @click="clearFilter">Clear filters</b-button>
          </div>
        </div>
        <grid-component
          isResizable
          isReorderable
          isSortable
          :canEdit="true"
          :canDelete="true"
          :gridId="gridId"
          :pageable="pageable"
          :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
          :take="pageInfo.pageSize"
          :itemData="itemData"
          :pageSizes="pageInfo.pageSize"
          :totalItems="pageInfo.totalItems"
          :fields="fields"
          :sortBy="pageInfo.sortBy"
          :sortOrder="pageInfo.sortOrder"
          :sortMethod="sortGrid"
          :onDelete="onDelete"
          :onEdit="onEdit"
          :styleCustom="'height: 680px'"
          :onNavigation="onNavigation"
          :handleRowClick="onRowClick"
          @getData="onGetData"
          :isTblLoader="tblLoader"
          :checkBoxValues="checkedContacts"
          @checkedItem="checkedContacts=$event"
        />
      </div>
    </b-card>
    <add-task :editDetails="taskDetails" fromContactsPage @refreshGrid="onClear"/>
    <CloseTask :taskDetails="todoTaskDetails" @refreshGrid="onClear"/>
    <b-modal size="lg" id="task-details-modal" title="Task Detail">
      <TaskDetail v-if="todoTaskDetails.id" :assignedUsers="getAllUser" :taskDetails="todoTaskDetails" @openTodoModal="openTaskDetailModal" @refreshGrid="onClear"/>
    </b-modal>
    <send-emails :sendEmailData="sendEmailData" @refresh="afterEmailSent" hideAttachments></send-emails>
  </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import {debounce} from 'lodash';
    import {GRID_PAGE_SIZES, GRID_ID, SEARCH_DEBOUNCE_TIME} from '@/shared/constants';
    import FixedHeader from '@/shared/components/FixedHeader/indexNew';
    import GridComponent from '@/shared/components/GridComponent';
    import gridFields from './fields';
    import {FIELDS} from './constants';
    import AddTask from '@/pages/Todotasks/components/add';
    import CloseTask from '@/pages/Todotasks/components/close';
    import TaskDetail from '@/pages/Todotasks/components/detail';
    import SendEmails from '@/shared/components/SendEmails/index';
    import { getDatesFromRangeString, sortAttributes, withAllOption } from '@/shared/helpers';    

    export default {
        components: {
          FixedHeader,
          GridComponent,
          AddTask,
          CloseTask,
          TaskDetail,
          SendEmails
        },
        metaInfo: () => ({
          title: 'Contacts',
        }),
        data() {
            return {
              fields: gridFields,
              gridId: GRID_ID.CONTACTS_GRID,
              pageable: {
                  pageSizes: GRID_PAGE_SIZES,
              },
              selectedRowItemId: 0,
              filterPageName: 'contactPage',
              isSaving:false,
              selectedRow: {
                companyId: 0,
                companyName: '',
                contactId: 0
              },
              taskDetails: {},
              todoTaskDetails: {},
              selectedTodoId: 0,
              isNewTodoTask: false,
              checkedContacts: [],
              sendEmailData: {},
              onMultiDeleting: false
            };
        },
        computed: {
            ...mapGetters('allContact', ['contactsList', 'pageInfo', 'filters', 'lastOpenedId', 'tblLoader']),
            ...mapGetters('account', ['gridSettingsById']),
            ...mapGetters('users', ['getAllUser']),
            ...mapState('buyerReps', ['buyerReps']),
            ...mapState('salesReps', ['salesReps']),
            ...mapGetters('accountClasses', ['accountClasses']),    
            ...mapState('lookup', ['accountTypeAttributes']),
            ...mapGetters('accountTypes', ['sortedAccountTypes']),
            ...mapGetters('address', ['countryCodes']),
            /*Get grid settings from store*/
            gridSettings() {
                return this.gridSettingsById(this.gridId);
            },
            filteredAttributes() {
              let attrib = [];
              let dist = [], flag = [];

              if(this.filterObj.accountTypeId > 0){
                attrib = this.accountTypeAttributes.filter(e => e.accountTypeId == this.filterObj.accountTypeId);
              }
              else{
                attrib = this.accountTypeAttributes;
              }

              for (let i = 0; i < attrib.length; i++) {
                if (flag.indexOf(attrib[i].attributeId) > -1) continue;
                dist.push(attrib[i])
                flag.push(attrib[i].attributeId);
              }
                
              return dist;
            },

            /*To show data in grid following function will be used*/
            itemData() {
                if (this.contactsList == undefined || this.contactsList.length === 0) return [];
                return this.contactsList.map((Contact) => ({
                    ...Contact,
                    selected: Contact.id === this.selectedRowItemId
                }));
            },

            /*Map store filter data with variable to set into filter form*/
            filterObj() {
                return this.filters[this.filterPageName] || {}
            },
            checkedContactEmails() {
              return this.itemData.filter(x => this.checkedContacts.includes(x.id)).map(x => x.email1);
            }
        },
        methods: {
            ...mapMutations('allContact', ['setItem']),
            ...mapActions('todotasks', { getTodoById: 'getById'}),
            ...mapActions('allContact', ['getAll', 'sortGrid', 'search', 'deleteRecord', 'multiDeleteContacts']),

            /*When user change page number select box this function will be called*/
            async onGetData(params) {
                await this.getAll(params);
            },

            /*When user make any changes into grid filter this function will be called and search data*/
            onSearch: debounce(function () {
                this.search({'filters': this.filterObj, page: this.filterPageName});
            }, SEARCH_DEBOUNCE_TIME),

            /*This function use to clear search data*/
            clearFilter() {
                Object.keys(this.filterObj).forEach(filterName => {
                    this.filterObj[filterName] = null;
                });

                this.search({'filters': this.filterObj, page: this.filterPageName});
            },

            /*When user click on grid row this function will be called and it's set selected row item if */
            onRowClick(row) {
              this.selectedRow = {};
              this.selectedRow.companyId = row.dataItem.companyId;
              this.selectedRow.companyName = row.dataItem.companyName;
              this.selectedRow.contactId = row.dataItem.id;

              this.setItem({resource: 'lastOpenedId', payload: row.dataItem.id});
              this.selectedRowItemId = row.dataItem.id;
            },

            /*When user click on navigation column(normally id) this function will be called and set last open id in state and redirect to edit page*/
            onEdit(row) {
                this.setItem({resource: 'lastOpenedId', payload: row.id});
                /*this.$router.push(`/company/${row.companyId}/contacts/${row.id}/details`)*/

              this.$router.push({
                name: 'company.contact.details',
                params: { id: row.companyId, contactId: row.id},
              });

            },

            /*When user click on delete button of grid it will called*/
            async onDelete(row) {
                /*Confirm delete with common mixin function and if confirmed then call delete api*/
                const deleteConfirmed = await this.openConfirmBox({});
                if (deleteConfirmed) {
                    /*Delete record*/
                    await this.deleteRecord(row.id);
                    /*After delete refresh grid*/
                    await this.getAll({});
                }
            },

            async onNavigation(row, field) {
                this.setItem({resource: 'lastOpenedId', payload: row.id});
                switch (field) {
                    case FIELDS.FULL_NAME:
                        /*this.$router.push(`/company/${row.companyId}/contacts/${row.id}/details`)*/
                        this.$router.push({
                          name: 'company.contact.details',
                          params: { id: row.companyId, contactId: row.id, isVisitedFromContacts: true},
                        });
                        break;
                    case FIELDS.COMPANY_NAME:
                        this.$router.push({ 
                          path: `/company/${row.companyId}/details`,
                          query: { listPage: 'Contacts' }
                        });
                        break;
                    case FIELDS.TASK_SUBJECT:
                        let todotask = await this.getTodoById(row.toDoTaskId);
                        this.selectedTodoId = row.toDoTaskId;
                        this.todoTaskDetails = Object.assign({}, todotask);
                        this.$bvModal.show('task-details-modal');

                        /*this.$router.push(`/company/${row.companyId}/contacts/${row.id}/tasks`)*/
                        break;
                }
            },
            openTodoModal() {
              this.taskDetails = {};

              this.taskDetails.companyId = this.selectedRow.companyId;
              this.taskDetails.companyName = this.selectedRow.companyName;
              this.taskDetails.contactId = this.selectedRow.contactId;
              this.isNewTodoTask = true;
              this.$bvModal.show('add-task-modal');
            },
            openTaskDetailModal(isAdd = false) {
              if (isAdd) {
                this.isNewTodoTask = true;
                this.taskDetails = {};
                this.taskDetails.companyId = this.todoTaskDetails.companyId;
                this.taskDetails.companyName = this.todoTaskDetails.companyName;
                this.$bvModal.show('add-task-modal');
              }else{
                this.isNewTodoTask = false;
                this.taskDetails = Object.assign({}, this.todoTaskDetails);
                if (this.taskDetails) {
                  setTimeout(() => {
                    this.$bvModal.show('add-task-modal');
                  }, 1000);
                }
              }
            },
            async onClear(){
              this.onSearch();
              if(!this.isNewTodoTask) {
                let todotask = await this.getTodoById(this.selectedTodoId);
                this.todoTaskDetails = Object.assign({}, todotask);
              }
            },
            onSendEmail() {
              
              if (this.checkedContactEmails.length > 0) {
                this.sendEmailData = {
                  source: 'Contacts',
                  to: this.checkedContactEmails.join('; '),
                  ReferenceId: 0
                }
                this.$root.$emit('bv::show::modal', 'send-email-modal');
              }
              
            },
            afterEmailSent() {
              this.checkedContacts = [];
            },
            redirectToAddRequirement() {
              if(this.selectedRow.companyId && this.selectedRow.contactId) {
                this.$router.push(`requirements/form?customer=${this.selectedRow.companyId}&contact=${this.selectedRow.contactId}`);
              } else {
                this.$router.push({
                  name: 'requirements.add.new',
                });
              }
            },
            async onMultiDeleteContacts() {
              let response = await this.openConfirmBox({ message: 'Are you sure you want to delete the selected contacts?' });
              if (response) {
                this.onMultiDeleting = true;
                await this.multiDeleteContacts(this.checkedContacts).then((res) => {
                  if (res)
                    this.$snotify.success('Contacts deleted successfully');
                  else 
                    this.$snotify.error('Contacts deleting failed');
                  this.checkedContacts = [];
                  this.getAll({});
                });
                this.onMultiDeleting = false;
              }
            }
        },
        watch: {
            /*When list of this page is changed then following function will be called*/
            contactsList() {
                //This function sets the first row as the selected row using common mixin function
                this.selectedRowItemId = this.setSelectedRowId(this.contactsList, this.selectedRowItemId, this.lastOpenedId);

                if (this.selectedRowItemId > 0) {
                  let selectedTblRow = this.contactsList.find(x => x.id == this.selectedRowItemId)
                  this.selectedRow = {};
                  this.selectedRow.companyId = selectedTblRow.companyId;
                  this.selectedRow.companyName = selectedTblRow.companyName;
                  this.selectedRow.contactId = this.selectedRowItemId;
                }
            }
        },
        async mounted() {
            this.setItem({resource: 'filterPage', payload: this.filterPageName});
            this.setItem({
                resource: 'pageInfo',
                payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize}
            });
            await this.getAll({});
        },
    };
</script>